<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hyC71T/tc-custom/9781667448084.jpg?1680418786353" alt="This image is the cover for the book Il camminatore di Cape"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Il camminatore di Cape
      </h1>
      <p class="bookDescription body article font2">
        <p>Il corpo di un uomo viene ritrovato a Cape, in una piccola comunità di pescatori della costa orientale del Canada. All'inizio tutti pensano a un infarto o a un ictus. Ma poi si scopre che l'uomo è stato avvelenato. Chi avrebbe potuto farlo e perché? Scoprirlo spetta al sergente Winston Windflower della RCMP insieme al suo fidato aiutante Eddie Tizzard. Durante il corso delle indagini, i due vengono a conoscenza di molti altri segreti nascosti in questa piccola comunità e di persone potenti che vogliono mantenerli tali.<br/> Windflower scopre anche altre due cose: l'amore per la vita in una piccola comunità che è completamente diversa dalla remota riserva indiana in cui è cresciuto e forse anche l'amore della sua vita. Scopre il sapore del cibo e dell'ospitalità della costa orientale e si rende conto di come il crimine e la corruzione possano annidarsi sotto alla superficie o nascondersi nella spessa coltre di nebbia che a volte si diffonde dal vicino Oceano Atlantico.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Martin, Elena Franzoni
      </h2>
      
      <p class="authorDescription body article">L’autore<br/> Mike Martin è nato a Terranova sulla costa orientale del Canada e ora vive e lavora a Ottawa, nell’Ontario. È uno scrittore freelance da molto tempo e i suoi articoli e saggi sono apparsi su giornali, riviste e online in tutto il Canada, negli Stati Uniti e in Nuova Zelanda. È l’autore di Change the Things You Can: Dealing with Difficult People e ha scritto numerosi racconti brevi apparsi su diverse pubblicazioni incluse Canadian Stories e la rivista Downhome. Il Camminatore del Capo è il suo primo libro di narrativa completo e la prima della serie misteriosa del sergente Windflower.<br/> È membro di Ottawa Independent Writers, Capital Crime Writers, Crime Writers of Canada e Newfoundland Writers’ Guild.<br/> Per ulteriori informazioni e per commentare questo libro, si prega di visitare: www.walkeronthecape.com<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fa09b000